import { Link } from 'react-router-dom';

const footerLinks = {
  热门分类: [
    { label: '足球赛事', path: '/category/football' },
    { label: '篮球赛事', path: '/category/basketball' },
    { label: '网球赛事', path: '/category/tennis' },
    { label: '电竞赛事', path: '/category/esports' },
    { label: '赛车赛事', path: '/category/racing' },
    { label: '格斗赛事', path: '/category/combat' },
  ],
  关于我们: [
    { label: '品牌介绍', path: '/about' },
    { label: '联系我们', path: '/about#contact' },
    { label: '用户协议', path: '/about' },
    { label: '隐私政策', path: '/about' },
    { label: '常见问题', path: '/#faq' },
  ],
  热门文章: [
    { label: '英超联赛前瞻', path: '/article/article-1' },
    { label: 'NBA新星盘点', path: '/article/article-2' },
    { label: '温网2026回顾', path: '/article/article-3' },
    { label: '电竞产业报告', path: '/article/article-4' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-trophy-line text-xl text-white"></i>
              </div>
              <span className="text-xl font-bold tracking-wide">开元体育</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md">
              开元体育是专业综合体育娱乐平台，汇聚全球顶级赛事资讯、实时数据与专业分析，为体育爱好者提供流畅、安全、多元的在线体育体验。
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold mb-5 text-white">{title}</h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 开元体育 版权所有 | 专业体育娱乐平台
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">用户协议</Link>
            <Link to="/about" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">隐私政策</Link>
            <Link to="/about" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}